import { Product } from '@setvi/shared/interfaces';

// ! PROPS
export interface ProductEnhancerProps {
  product: Product;
}

// ! FIELD
export enum EProductEnhancerFieldTypes {
  TEXTAREA = 'textarea',
  TITLE = 'title',
  LABEL_VALUE = 'label_value',
  TAG = 'tag'
}

interface IProductEnhancerFieldBase {
  id: string;
  title: string;
  type: EProductEnhancerFieldTypes;
}

export interface ITextareaField extends IProductEnhancerFieldBase {
  type: EProductEnhancerFieldTypes.TEXTAREA;
  data: string;
}

export interface ITitleField extends IProductEnhancerFieldBase {
  type: EProductEnhancerFieldTypes.TITLE;
  data: string;
}

export interface ILabelValueField extends IProductEnhancerFieldBase {
  type: EProductEnhancerFieldTypes.LABEL_VALUE;
  data: { label: string; value: string }[];
}

export interface ITagField extends IProductEnhancerFieldBase {
  type: EProductEnhancerFieldTypes.TAG;
  data: string[];
}

export type IProductEnhancerField =
  | ITagField
  | ITitleField
  | ITextareaField
  | ILabelValueField;

export type IEnhancedField = IProductEnhancerField | IProductEnhancerFieldBase;

// ! STATE STRUCTURE
export type EnhancedFieldsMapState = Record<string, IEnhancedField>;

// ! CSV
export type EnhancedFieldCsvRow = Record<string, string>;

// ! TYPE GUARDS
export const isProductEnhancerField = (
  field: IEnhancedField
): field is IProductEnhancerField => !!(field as IProductEnhancerField).data;

export const isLabelValueField = (
  field: IEnhancedField
): field is ILabelValueField =>
  field.type === EProductEnhancerFieldTypes.LABEL_VALUE;

// ! HANDLERS
export type onEnhanceClickHandler = (fieldId: IEnhancedField['id']) => void;

export type onReEnhanceClickHandler = (fieldId: IEnhancedField['id']) => void;

export type onTagRemoveClickHandler = (
  fieldId: IProductEnhancerField['id'],
  tag: string
) => void;

export type onTextAreaChangeHandler = (
  fieldId: ITextareaField['id'],
  value: string
) => void;

export type onLabelValueChangeHandler = (
  fieldId: ILabelValueField['id'],
  itemIndex: number,
  value: string
) => void;
